/**
 * CuentaLayout — v8.5.23 · F3 · shell de la zona "Cuenta".
 *
 * Brand, Documentos, Equipo, Facturas y Configuración vivían repartidos en
 * 3 grupos distintos del Sidebar (Tu marca / Personal / dropdown de usuario)
 * sin relación visible entre sí, aunque ninguno comparte datos ni filtros
 * con los demás — son 5 páginas de "esto es tu cuenta con la agencia".
 * Ahora conviven bajo un solo shell con pestañas; las páginas en sí no se
 * tocan, solo pasan a rendirse dentro de este <Outlet/>.
 */
import { useLocation } from "react-router-dom";
import { Sparkles, FileText, Users, DollarSign, Settings } from "lucide-react";
import ZoneNav from "./ZoneNav.jsx";

const TABS = [
  { to: "/cuenta/brand",         label: "Brand",       icon: Sparkles },
  { to: "/cuenta/documentos",    label: "Documentos",  icon: FileText },
  { to: "/cuenta/equipo",        label: "Tu equipo",   icon: Users },
  { to: "/cuenta/facturas",      label: "Facturas",    icon: DollarSign },
  { to: "/cuenta/configuracion", label: "Configuración", icon: Settings },
];

export default function CuentaLayout() {
  const { pathname } = useLocation();
  const items = TABS.map(t => ({ ...t, active: pathname === t.to || pathname.startsWith(t.to + "/") }));
  return <ZoneNav items={items}/>;
}
